// getRatingColor.js
'use strict';

/**
 * Get rating color based on rating value and thresholds
 * @param {number} rating - Rating value
 * @param {Array} thresholds - ex. ['4.8:FFD100', '4.1:FFFFFF', '0:9B9B9B']
 * @param {string} defaultColor - Default color when no threshold matches
 * @returns {Object} Object containing ratingColor
 */
const getRatingColor = ({ rating, thresholds, defaultColor = '9B9B9B' }) => {
  const parsedThresholds = thresholds.map(item => {
    const [score, color] = item.split(':');
    return [parseFloat(score), color];
  });

  const sortedThresholds = parsedThresholds.sort((a, b) => b[0] - a[0]);

  const matchedEntry = sortedThresholds.find(
    ([threshold]) => rating >= threshold
  );
  const ratingColor = matchedEntry ? `#${matchedEntry[1]}` : `#${defaultColor}`;

  return { ratingColor };
};

export default getRatingColor;
